/**
 * @deprecated This component is deprecated. Use FullScreenLoader.tsx instead.
 */
import { TransactionHeader } from '@components/global/styled';

export const LoadScreen = () => {
  return (
    <div data-testid="LoadScreen">
      <TransactionHeader>
        <h1>Loading...</h1>
      </TransactionHeader>
    </div>
  );
};
